import { render, staticRenderFns } from "./BaseH2.vue?vue&type=template&id=7c610dac&"
import script from "./BaseH2.vue?vue&type=script&lang=js&"
export * from "./BaseH2.vue?vue&type=script&lang=js&"
import style0 from "./BaseH2.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports